// Client for the Research Academia main user-preferences API.
// Endpoint:  GET/PATCH /api/user-preferences
//
// The endpoint merges partial PATCH bodies, so we only send the fields
// we are changing. All keys are namespaced with `pod_` to avoid colliding
// with the existing reference-client keys.

import { tokenStorage } from './client';

const USER_API_BASE =
  process.env.REACT_APP_USER_API_BASE || '';

const ENDPOINT = `${USER_API_BASE}/api/user-preferences`;

async function authedFetch(method, body) {
  const token = tokenStorage.getAccess();
  if (!token) throw new Error('No access token');

  const res = await fetch(ENDPOINT, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    throw new Error(`user-preferences ${method} failed (${res.status})`);
  }
  return res.json().catch(() => ({}));
}

export const userPreferencesApi = {
  get: async () => {
    const json = await authedFetch('GET');
    // The API may return { preferences: {...} } or the object directly.
    return json.preferences || json.data || json || {};
  },

  patch: async (partial) => {
    const json = await authedFetch('PATCH', partial);
    return json.preferences || json.data || json || {};
  },
};
